const SOCIAL_LINKS = {
  youtube: 'http://youtube.com/bup',
  instagram: 'http://instagram.com/bup',
  tiktok: 'http://tiktok.com/bup',
  facebook: 'http://facebook.com/bup',
  twitter: 'http://twitter.com/bup',
};

export default SOCIAL_LINKS;
